const retailerHiddenFields = {
    jbg: [
        'brand_owner',
        'buyer_id',
        'buyer_name',
        'corporation_code',
        'division_code',
        'facility_code',
        'folder_date',
        'input_file_name',
        'item_billing_cost',
        'load_date',
        'load_timestamp',
        'local_vendor_flag',
        'old_dc_code',
        'old_warehouse_code',
        'primary_cic_flag',
        'primary_upc_flag',
        'product_reclamation_flag',
        'product_type_description',
        'product_type_code',
        'is_private_label',
        'record_type',
        'transaction_type',
        'vendor_cost',
        'vendor_cost_change_date',
        'vendor_number',
        'vendor_name',
        'vendor_sub_account'
    ]
}

export { retailerHiddenFields }


// WEBPACK FOOTER //
// ./src/components/items/data/metadataFields.js